import { render, staticRenderFns } from "./lnk.vue?vue&type=template&id=3fe50916"
import script from "./lnk.vue?vue&type=script&lang=js"
export * from "./lnk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports